import { gql, TypedDocumentNode } from "@apollo/client";

import { ConfListFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { confListFragment } from "src/graphql/anti-fraud/fragments/ConfListFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToConfList } from "src/mappers/confList.mappers";

type GetAllConfListsQueryData = {
  fraudConfLists: ConfListFragmentFragment[];
};

export const getAllConfListsQuery = gql`
  query GetAllConfLists {
    fraudConfLists {
      ...ConfListFragment
    }
  }

  ${confListFragment}
` as TypedDocumentNode<GetAllConfListsQueryData, Record<string, never>>;

export const useGetAllConfListsQuery = () => {
  return useFetchQuery(getAllConfListsQuery, {
    toData: (data) => (data?.fraudConfLists ?? []).map(mapToConfList),
    isEmpty: (data) => !data?.fraudConfLists?.length,
    uiErrors: {
      fetchError: "FETCH-CONFLIST-ERROR",
      emptyError: "EMPTY-CONFLIST-ERROR",
    },
  });
};
